import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductComponent } from './product/product.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { HttpModule } from '@angular/http';
import { SlickCarouselComponent } from './slick-carousel/slick-carousel.component';
import { FindCriteriaComponent } from './find-criteria/find-criteria.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProofComponent } from './proof/proof.component';
import { BusySpinnerComponent } from './busy-spinner/busy-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    NgbModule
  ],
  declarations: [
    ProductComponent,
    FileUploadComponent,
    SlickCarouselComponent, 
    FindCriteriaComponent,
    ProofComponent,
    BusySpinnerComponent
  ],
  exports: [
    ProductComponent,
    FileUploadComponent,
    SlickCarouselComponent,
    FindCriteriaComponent,
    ProofComponent,
    BusySpinnerComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts